import {createAsyncThunk, createSlice, createAction} from "@reduxjs/toolkit";
import Keycloak from "keycloak-js";

const keycloakConfig = {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID
};

const keycloakInitOptions = {
    // Configure that Keycloak will check if a user is already authenticated (when opening the app or reloading the page). If not authenticated the user will be send to the login form. If already authenticated the webapp will open.
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
    redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URL,
};


const initialState = {
    isAuthenticated: false,
    isInit: false,
    username: undefined,
    keycloak: new Keycloak(keycloakConfig)
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        hasRole: (state, action) => {
            console.log("hasRole");
            const {keycloak} = state;
            return keycloak.hasRealmRole(action);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(initKeycloak.pending, (state, action) => {
                console.log('init pending...');
            })
            .addCase(initKeycloak.fulfilled, (state, action) => {
                const {payload: isAuthenticatedResponse} = action;
                state.isAuthenticated = isAuthenticatedResponse;
                state.isInit = true;
                state.keycloak.onTokenExpired = () => {
                    console.log('token expired ....');
                    state.keycloak.updateToken(600)
                };
                console.log('init fulfilled...' + isAuthenticatedResponse);
            })
            .addCase(login.fulfilled, (state, action) => {
                console.log('login fulfilled...');
                state.isAuthenticated = true;
            })
            .addCase(logout.fulfilled, (state, action) => {
                console.log('logout fulfilled...');
                state.isAuthenticated = false;
            })
    }
})

export const initKeycloak = createAsyncThunk('auth/initKeycloak', (arg, thunkAPI) => {
    console.log('auth/initKeycloak');
    const { auth : {keycloak} } = thunkAPI.getState();
    return keycloak.init(keycloakInitOptions);
})

export const login = createAsyncThunk('auth/login', (url, {getState} ) => {
    console.log('auth/login');
    const { auth : {keycloak}} = getState();
    return keycloak.login({redirectUri: window.location.origin + url});
})

export const initAndLogin = createAction(
    "auth/initAndLogin",
    async (url, dispatch) => {
        const {payload: auth = false} = await dispatch(initKeycloak());
        if(!auth)
            await dispatch(login(url));
    }
);


export const logout = createAsyncThunk('auth/logout', (arg, {getState} ) => {
    console.log('auth/logout');
    const { auth : {keycloak}} = getState();
    return keycloak.logout();
})

export const { hasRole, initApiService } = authSlice.actions

export const selectIsAuthenticated = state => state.auth.isAuthenticated;
export const selectToken = state => state.auth.keycloak.token;
export const selectIsInit = state => state.auth.isInit;
export const selectUsername = state => state.auth.username;

export default authSlice.reducer
